export default __webpack_public_path__ + "static/media/email.bf814f6d.svg";